interface BitrixApi {
  init(callback: () => void): void;
  getAuth(): unknown;
}

declare global {
  interface Window { BX24?: BitrixApi; }
}

let scriptPromise: Promise<void> | undefined;

function loadBitrixApi(): Promise<void> {
  if (window.BX24) return Promise.resolve();
  if (window.parent === window) return Promise.resolve();
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-bitrix24-api="true"]');
    if (existing) { existing.addEventListener("load", () => resolve(), { once: true }); existing.addEventListener("error", () => reject(new Error("Bitrix24 API script failed")), { once: true }); return; }
    const script = document.createElement("script"); script.src = "https://api.bitrix24.com/api/v1/"; script.async = true; script.dataset.bitrix24Api = "true";
    script.addEventListener("load", () => resolve(), { once: true }); script.addEventListener("error", () => reject(new Error("Bitrix24 API script failed")), { once: true }); document.head.appendChild(script);
  });
  return scriptPromise;
}

export async function syncBitrixSession(): Promise<boolean> {
  if (typeof window === "undefined") return false;
  try {
    await loadBitrixApi();
    if (!window.BX24) return false;
    const auth = await new Promise<unknown>((resolve) => window.BX24?.init(() => resolve(window.BX24?.getAuth())));
    if (!auth) return false;
    const response = await fetch("/api/auth", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ auth }) });
    return response.ok;
  } catch {
    return false;
  }
}
